import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Button, Input, Checkbox, Form, Radio } from "antd";
import $ from "jquery";

import {
  setSecret,
  addGetSecretAction,
} from "../../../../../../../redux/actions/azure";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import imageIcon from "../../../../../../../images/image-pic.png";
import { getFileUrl } from "../../../../../../../redux/actions/fileUpload";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import captureXpathIcon from "../../../../../../../images/capture-xpath.png";
import ReactTooltip from "react-tooltip";

let url = null;
const AdvancedConfigForm = ({
  data,
  updateConfig,
  addGetSecretAction: add,
}) => {
  // const [form] = Form.useForm();

  const [fieldData, setFieldData] = useState({
    record: null,
    mandatory_fields: [],
    optional_fields: [],
    default_values: [],
  });

  const skill = useSelector((state) => state.skillReducer.trainDraft);

  const [errors, setErrors] = useState({});
  const [secretCheck, setSecretCheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [frameData, setFrameData] = useState();
  const [xpathValue, setXpathValue] = useState();
  const [selectorXpathValue, setSelectorXpathValue] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [incognitoValue, setIncognitoValue] = useState();
  const [imageURL, setImageURL] = useState(null);
  const [framework, setFramework] = useState("");

  const updateImage = async (file) => {
    setIsFileLoading(true);
    url = await store.dispatch(getFileUrl(file));
    setImageURL(url);
    setIsFileLoading(false);
  };

  useEffect(() => {
    setFieldData(data);
    setXpathValue(data?.record?.xpath);
    setSelectorXpathValue(data?.record?.selector);
    setImageURL(data?.record?.image);
    setIncognitoValue(incognitoValue);

    setSelectedValue(selectedValue);
    try {
      if (data.record.textType === "secret") {
        setSecretCheck(true);
      }
    } catch (err) {}
  }, [data, incognitoValue, selectedValue]);

  const validateFields = (fields, requiredFields) => {
    let errors = {};
    requiredFields.forEach((i) => {
      if (!Boolean(fields[i].length)) {
        errors[i] = true;
      }
    });
    return errors;
  };

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleSubmit = async () => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();
    let result;
    setIsLoading(true);
    if (secretCheck) {
      result = await storeInVault(data.record.text);

      trainDraft = result?.draft;
    }
    let payload = {};
    let form = $("#advanceConfigPanel");
    let _formData = form.serializeArray();
    _formData.forEach((i) => (payload[i.name] = i.value));
    Object.assign(payload, result?._secretKey);
    let errors = validateFields(payload, [...data.mandatory_fields]);
    if (!$.isEmptyObject(errors)) {
      setErrors(errors);
      setIsLoading(false);
    } else {
      if (url !== null) {
        payload.image = url;
      }
      if (trainDraft?.RAW_DATA?.variables) {
        trainDraft.RAW_DATA.variables.forEach((key) => {
          if (key.id == fieldData?.record?.id) {
            key.value = payload.text;
          }
        });
      }

      let newActions = findAndUpdate(
        trainDraft?.RAW_DATA?.actions,
        fieldData?.record?.id,
        payload
      );

      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );
      updateConfig(payload, data.record.id);
      url = null;
    }
  };

  const storeInVault = async (secretValue) => {
    const result = await setSecret(secretValue);
    if (result.status) {
      let _secretKey = {
        text: `\`${result.data.secretName}\``,
        textType: "secret",
      };

      let draft = add(data.record.id, result.data.secretName);
      return { _secretKey, draft };
    }
  };

  const xPathHandler = (evt) => {
    const xPath = evt.detail.xPath;
    const frame = evt.detail.frame;
    setFrameData(frame);
    data.record.xPath = xPath;
    setXpathValue(data?.record?.xPath);
    data.record.selector = xPath;
    setSelectorXpathValue(data?.record?.selector);
  };

  const captureXpath = (nodeId) => {
    window?.chrome?.runtime.sendMessage(process.env.REACT_APP_CHROME_TAB_ID, {
      type: "captureXPath",
      nodeId: nodeId,
    });
  };

  const handleXpath = (e) => {
    setXpathValue(e.target.value);
  };

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleIncognito = (e) => {
    setIncognitoValue(e.target.value);
  };

  const handleSelectorXpath = (e) => {
    setSelectorXpathValue(e.target.value);
  };

  const selectFramework = (e) => {
    if ((e.target.value = 1)) {
      setFramework("Selenium");
    } else {
      setFramework("Playwright");
    }
  };

  useEffect(() => {
    document.addEventListener("capturedXPath", xPathHandler);
    return () => {
      console.log("[Unmounting]");
      document.removeEventListener("capturedXPath", xPathHandler, true);
    };
  }, []);

  return (
    <div>
      <form id="advanceConfigPanel">
        {fieldData.mandatory_fields.map((field, index) => {
          return (
            <div
              key={`${field}-${fieldData.record.id}`}
              style={{ marginBottom: 15 }}
            >
              <div className="ant-form-item-label">
                <label>
                  {field === "url"
                    ? field.toUpperCase()
                    : field.charAt(0).toUpperCase() +
                      field.slice(1).toLowerCase()}
                  <span style={{ color: "red" }}>*</span>{" "}
                </label>
                {field == "text" && skill?.TEMPLATE !== "In-App Walkthrough" ? (
                  <Checkbox
                    checked={secretCheck}
                    disabled={secretCheck === true}
                    onChange={(e) => setSecretCheck(e.target.checked)}
                  >
                    Store in Vault
                  </Checkbox>
                ) : null}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {field === "xpath" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    value={xpathValue}
                    onChange={handleXpath}
                    disabled={fieldData?.record?.textType === "secret"}
                  />
                ) : null}
                {field === "text" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    defaultValue={fieldData?.record?.[field]}
                    disabled={fieldData?.record?.textType === "secret"}
                  />
                ) : null}
                {field === "selector" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    value={selectorXpathValue}
                    onChange={handleSelectorXpath}
                    disabled={fieldData?.record?.textType === "secret"}
                  />
                ) : null}
                {field === "url" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    defaultValue={fieldData?.record?.[field]}
                    disabled={fieldData?.record?.textType === "secret"}
                  />
                ) : null}
                {field === "xpath" || field === "selector" ? (
                  <Button
                    className="capture-btn"
                    style={{ height: "30px" }}
                    onClick={() => {
                      captureXpath(fieldData?.record?.id);
                    }}
                    icon={
                      <img
                        src={captureXpathIcon}
                        data-tip="Capture Xpath"
                      ></img>
                    }
                  ></Button>
                ) : null}
                {field === "value" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    defaultValue={fieldData?.record?.[field]}
                  />
                ) : null}
                {field === "description" ? (
                  <Input
                    name={field}
                    label={field.toUpperCase()}
                    defaultValue={fieldData?.record?.[field]}
                  />
                ) : null}

                {field === "imgSelector" ? (
                  <div className="img-input-upload">
                    <Input
                      name={field}
                      label={field.toUpperCase()}
                      defaultValue={fieldData?.record?.[field]}
                      value={imageURL}
                    />
                    {fieldData.record?.origin ? (
                      isFileLoading ? (
                        <div className="rth-upload">
                          <div className="upload-btn-wrapper">
                            <div class="sp sp-circle text-light"></div>
                          </div>
                        </div>
                      ) : (
                        <div className="rth-upload">
                          <div className="upload-btn-wrapper">
                            <button class="btn btn-rth-upload">
                              <img src={imageIcon} />
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  updateImage(e.target.files[0]);
                                }}
                              ></input>
                            </button>
                          </div>
                        </div>
                      )
                    ) : null}
                  </div>
                ) : null}
                <ReactTooltip place="top" type="dark" effect="solid" />
              </div>
              {errors[field] ? (
                <span style={{ color: "red", fontSize: 12 }}>
                  {" "}
                  {field} field is mandatory *
                </span>
              ) : null}
            </div>
          );
        })}

        {fieldData.optional_fields.map((field, index) => {
          return (
            <div
              key={`${field}-${fieldData.record.id}`}
              style={{ marginBottom: 15 }}
            >
              {/* <div className="ant-form-item-label">
                <label>{field.toUpperCase()} </label>
              </div>

              <Input
                name={field}
                label={field.toUpperCase()}
                defaultValue={
                  imageURL && field == "imgSelector"
                    ? imageURL
                    : fieldData?.record?.[field]
                }
              ></Input> */}
              {field !== "path" && (
                <div className="ant-form-item-label">
                  <label>
                    {field.charAt(0).toUpperCase() +
                      field.slice(1).toLowerCase()}{" "}
                  </label>
                </div>
              )}

              {field !== "path" && (
                <Input
                  name={field}
                  label={
                    field.charAt(0).toUpperCase() + field.slice(1).toLowerCase()
                  }
                  defaultValue={
                    imageURL && field === "imgSelector"
                      ? imageURL
                      : fieldData?.record?.[field]
                  }
                ></Input>
              )}
              {errors[field] ? (
                <span style={{ color: "red", fontSize: 12 }}>
                  {" "}
                  {field} is mandatory *
                </span>
              ) : null}
            </div>
          );
        })}

        {fieldData.default_values.map((field, index) => {
          return (
            <div
              key={`${field}-${fieldData.record.id}`}
              style={{ marginBottom: 15 }}
            >
              <div className="ant-form-item-label">
                <label>
                  {field.charAt(0).toUpperCase() + field.slice(1).toLowerCase()}{" "}
                </label>
              </div>
              {fieldData?.record?.type === "OPEN_WEB_PAGE" ? (
                <Form.Item>
                  <Radio.Group
                    name={field}
                    label={field.toUpperCase()}
                    defaultValue={fieldData?.record?.[field]}
                    onChange={(e) => handleChange(e, "browser")}
                    checked={fieldData?.record?.[field]}
                  >
                    <Radio value={"chrome"}>Google Chrome</Radio>
                    {/* <Radio value={"msedge"}>Microsoft Edge</Radio> */}
                  </Radio.Group>
                </Form.Item>
              ) : (
                <Input
                  name={field}
                  label={field.toUpperCase()}
                  defaultValue={fieldData?.record?.[field]}
                />
              )}
              {fieldData?.record?.type === "OPEN_WEB_PAGE" ? (
                <>
                  <Form.Item label="Use Incognito Window">
                    <Radio.Group
                      name="useIncognito"
                      defaultValue={fieldData?.record?.useIncognito}
                      onChange={(e) => handleIncognito(e, "useIncognito")}
                      checked={fieldData?.record?.useIncognito}
                    >
                      <Radio value={"true"}>True</Radio>
                      <Radio value={"false"}>False</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item label="Pick Your Automation Framework">
                    <Radio.Group
                      name="browserAutomationType"
                      defaultValue={
                        fieldData?.record?.browserAutomationType == 1 ? 1 : 0
                      }
                      onChange={(e) =>
                        selectFramework(e, "browserAutomationType")
                      }
                      checked={fieldData?.record?.browserAutomationType}
                    >
                      <Radio value={0}>Playwright</Radio>
                      <Radio value={1}>Selenium</Radio>
                    </Radio.Group>
                  </Form.Item>
                </>
              ) : null}

              {errors[field] ? (
                <span style={{ color: "red", fontSize: 12 }}>
                  {" "}
                  {field} is mandatory *
                </span>
              ) : null}
            </div>
          );
        })}
        {/* {fieldData.record?.origin ? (
          <div className="rth-upload">
            <div className="upload-btn-wrapper">
              <button class="btn btn-rth-upload">
                <img src={imageIcon} />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    updateImage(e.target.files[0]);
                  }}
                ></input>
              </button>
            </div>
          </div>
        ) : (
          ""
        )} */}
      </form>

      <div>
        <Button type="primary" onClick={handleSubmit}>
          {isLoading ? <div class="sp sp-circle text-light"></div> : "Save"}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  skillReducer: state.skillReducer,
  userReducer: state.userReducer,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    addGetSecretAction,
  })
)(AdvancedConfigForm);
